import './DataTableGanttChartGrid.css';
export var ganttChartGrid = '_evozey0-3-5-0';